/* global Config */

// Vendor Libs
import {get, cloneDeep, set} from 'lodash';

const formInitialState = {
    formErrors: null,
    fieldErrors: {},
    location: null,
    operators: {},
    values: {},
    requestPath: null,
    submitted: false,
};

const genres = Config.base.matureContent ? 'Adult' : '!Adult';

const formsInitialStates = {
    bestMatches: {
        ...cloneDeep(formInitialState),
        operators: {
            titleLanguages: '=in=',
        },
        values: {
            genres,
            titleLanguages: ['en', 'es'],
            '#franchiseOnlyImages': 'true',
        },
    },
    createUser: set(cloneDeep(formInitialState), 'values', {
        active: true,
        clientSecret: 'ChangeMe!',
    }),
    editUser: set(cloneDeep(formInitialState), 'values', {active: true}),
    shelfItems: set(cloneDeep(formInitialState), 'values', {activeOnly: 'false'}),
    moviesAndPrograms: {
        ...cloneDeep(formInitialState),
        operators: {
            descriptionLanguage: '=in=',
            titleLanguages: '=in=',
        },
        values: {
            descriptionLanguage: ['en', 'es'],
            genres,
            titleLanguages: ['en', 'es'],
        },
    },
    moviesAndProgramsMappingFranchise: {
        ...cloneDeep(formInitialState),
        operators: {
            descriptionLanguage: '=in=',
            titleLanguages: '=in=',
        },
        values: {
            descriptionLanguage: ['en', 'es'],
            genres,
            titleLanguages: ['en', 'es'],
        },
    },
    moviesAndProgramsMappingEpisodes: set(cloneDeep(formInitialState), 'values', {genres}),
    mediaItemReenrich: set(cloneDeep(formInitialState), 'values', {targetValue: 'ENRICHMENT'}),
    mediaItemsReenrich: set(cloneDeep(formInitialState), 'values', {targetValue: 'ENRICHMENT'}),
};

export default function getFormInitialState(formName) {
    return cloneDeep(get(formsInitialStates, formName, formInitialState));
}
